import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionPage.module.css";
import axios from 'axios';
import { useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { loginApi } from '../Http/http';

const LoginPage = () => {
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(true);
    const [subscribeLoading, setSubscribeLoading] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            if (msisdn?.trim().length > 0) {

                setSubscribeLoading(true);

                let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

                if (msisdnWithCountryCode.startsWith('0')) {
                    msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
                }

                if (!msisdnWithCountryCode.startsWith('278')) {
                    msisdnWithCountryCode = '278' + msisdnWithCountryCode;
                }


                // let msisdn2 = msisdn;
                // if (!msisdn2.startsWith("278")) {
                //     msisdn2 = "278" + msisdn2;
                // }

                const response = await axios.post(loginApi, {
                    msisdn: msisdnWithCountryCode,
                    ext_ref: extRef,
                });

                console.log(response, 'response...');

                setSubscribeLoading(false);
                Cookies.set('msisdn', msisdnWithCountryCode, { expires: 1 });
                navigate("/home");
            }
            else {
                toast.error("Please Enter the Number!");
                return;
            }

        } catch (error) {
            console.log(error, 'error---');
            setSubscribeLoading(false);

            if (error?.response?.status == 400) {
                toast.error("You are not Subscribed! Please Subscribe First!");
            }
            else if (error?.response?.status === 500) {
                toast.error("Something went wrong on the server. Please try again later.");
            } else {
                console.log(error, 'erro---');
                toast.error("Something Went Wrong!");
            }
        }
    }

    return (
        <main className={classes.main}>
            {/* <div className={classes.header}>
                <img
                    src="wp-content/uploads/2024/04/cropped-Door2games-180x180.png"
                    className={classes.logo}
                    alt="gamezir"
                />
            </div> */}

            <div className={classes.container}>
                <h1 className={classes.portalDescription}>Tech Games</h1>

                <div className={classes.landingPageBanner}>
                    <img src="/images/banner.gif" alt="Banner" className={classes.banner} />
                </div>

                <>

                    <div className={classes.actions_box_container}>
                        <div className={classes.actions_box}>
                            <button type="button" className={`${classes.action_box} ${classes.active}`}
                            // onClick={() => navigate("/login")}
                            >
                                Login
                            </button>
                            <button type="button" className={`${classes.action_box}`}
                                onClick={() => navigate(`/?ext_id=${extRef}`)}
                            >
                                Subscribe
                            </button>
                        </div>
                    </div>
                    <input type='number' placeholder='Enter your Number' value={msisdn} onChange={(e) => setMsisdn(e.target.value)}
                        className={classes.input}
                    />
                    <button className={classes.subscribeBtn} id="subscribe_btn" onClick={handleLogin}
                        disabled={subscribeLoading}
                    >
                        {subscribeLoading ? "Loading..." : (
                            <>
                                Login <img src="images/lock.png" alt="lock" className={classes.lockImg} />
                            </>

                        )}
                    </button>

                    {/* <p className={classes.subscriptionChargeText}>Subscription KSH 15/Day</p> */}

                    {/* <div className={classes.termsSection}>
                        <h1 className={classes.termsHeading}>Terms & Conditions</h1>
                        <ul className={classes.termsList}>
                            <li>The service cost is KSH 15/day.</li>
                            <li>Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.</li>
                            <li>You can unsubscribe from the service anytime, by dialling USSD code *xxx# or deactivating from the portal.</li>
                            <li>All data-enabled features & Smartphone users can enjoy full service.</li>
                            <li>Customer can access the content at any time during the subscription validity period.</li>
                        </ul>
                    </div> */}
                </>

                <div style={{ width: "100%", display: "grid", placeContent: "center" }}>

                    <button className={classes.loginLink} onClick={() => navigate(`/?ext_id=${extRef}`)}>
                        Not a User, Subscribe Now
                    </button>
                </div>
            </div>
        </main>
    )
}

export default LoginPage